import { Popconfirm } from 'antd';
import { BiEdit, BiGrid } from 'react-icons/bi';
import { BsClock } from 'react-icons/bs';
import { PiClockUser } from 'react-icons/pi';
import { TbTrash } from 'react-icons/tb';
import { Link } from 'react-router-dom';

export const columns = ({ t, setSelectedItem, modal, navigation, deleteData, setModal, lang }) => [
    {
        title: "",
        key: "empty",
        width: 50,
        render: (a) => {
            return (
                <div className='h40px w40px round border d-flex justify-content-center align-items-center'>
                    {
                        a?.files.length > 0 && a?.files[0]
                            ? <img src={a?.files[0]} alt='' className='w-100 h-100 round cover' />
                            : <span className='color4'>{a?.id}</span>
                    }
                </div>
            )
        }
    },
    {
        title: t('title'),
        key: t('title'),
        sorter: (a, b) => a?.title[lang].localeCompare(b.title[lang]),
        render: (a) => {
            return <Link className='text-decoration-none text-dark' to={`/form-elements/${a?.id}`}>{a?.title[lang]}</Link>
        }
    },
    {
        title: t('changed_at'),
        key: 'changed_at',
        sorter: (a, b) => new Date(a?.updatedAt ? a?.updatedAt : a?.createdAt) - new Date(b?.updatedAt ? b?.updatedAt : b?.createdAt),
        render: (a) => {
            return (
                <div className='d-flex justify-content-start align-items-center'>
                    <div><BsClock size={20} className='color4' /></div>
                    <div className='ml-2'>
                        <div><span>{new Date(a?.updatedAt ? a?.updatedAt : a?.createdAt).toLocaleDateString("tr-TR")}</span></div>
                        <div><small className='color4'>{new Date(a?.updatedAt ? a?.updatedAt : a?.createdAt).toLocaleTimeString("tr-TR")}</small></div>
                    </div>
                </div>
            )
        }
    },
    {
        title: t("make_user"),
        key: 'make_user',
        sorter: (a, b) => a?.user.firstName - b?.user.firstName,
        render: (a) => {
            return (
                <div className='d-flex justify-content-start align-items-center'>
                    <div><PiClockUser size={25} className='color4' /></div>
                    <div className='ml-2'>
                        <div><span>{a?.user?.firstName + " " + a?.user?.lastName.toUpperCase()}</span></div>
                        <div><small className='color4'>{a?.user?.email}</small></div>
                    </div>
                </div>
            )
        }
    },
    {
        title: t('process'),
        render: (a) => {
            return (
                <div className='d-flex justify-content-start'>
                    <div
                        onClick={() => { setSelectedItem(a?.id); setModal(!modal) }}
                        className='text-warning border border-warning rounded p-2 cp'
                    >
                        <BiEdit size={22} />
                    </div>
                    <div
                        onClick={() => navigation(`/form-elements/${a?.id}`)}
                        className='mx-2 text-info border border-info rounded p-2 cp'
                    >
                        <BiGrid size={22} />
                    </div>
                    <div className='text-danger border border-danger rounded p-2 cp'>
                        <Popconfirm
                            title={t("content_delete_desc")}
                            onConfirm={() => deleteData(a?.id)}
                            okText={t("yes")}
                            cancelText={t("no")}
                        >
                            <TbTrash size={22} />
                        </Popconfirm>
                    </div>
                </div >
            )
        }
    }
];